<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="consignment-details-main" v-if="cnDetails">
    <div class="content-container">
      <div class="body-container" :class="{ 'is-loading': isLoading }">
        <div class="loading-overlay" v-if="isLoading">
          <div class="loading-spinner"></div>
        </div>
        <div class="cn-details-card">
          <div class="header" style="background-color: #535cda; color: white">
            <div class="label"> Consignment Details </div>
            <img
              class="expand-all"
              src="https://dsmlib.logistics.systems/Icons/Expand.png"
              alt="Expand All"
              title="Expand All"
              @click="expandAllBoxContainers"
            />
            <img
              class="collapse-all"
              src="https://dsmlib.logistics.systems/Icons/Collapse.png"
              alt="Collapse All"
              title="Collapse All"
              @click="collapseAllBoxContainers"
            />
          </div>
          <div class="details-container">
            <div class="container-info">
              <div class="top-details">
                <Input :inputValue.sync="containerNo" placeholder="Container #" :isDisabled="true" />
                <Input :inputValue.sync="requestNo" placeholder="Request #" :isDisabled="true" />
                <Input :inputValue.sync="updatedBy" placeholder="Updated By" :isDisabled="true" />
                <Input :inputValue.sync="lastUpdated" placeholder="Last Updated" :isDisabled="true" />
              </div>
            </div>
            <div class="cn-details">
              <BoxContainer
                style="margin-top: 0"
                :isCollapsible="true"
                :isCollapsed.sync="cnDetailsBoxContainersCollapsed.jobInfo"
                title="Job Information"
                ref="jobInfo"
                @collapseArrowClicked="boxContainerCollapseArrowClicked"
              >
                <div class="container-info">
                  <div class="container-info-main">
                    <div class="container-info-fields">
                      <div class="container-info-row" style="grid-template-columns: repeat(3, 1fr)">
                        <InputQuery
                          :placeholder="cnDetails[0].JobTypeHeader === 'E' ? 'Shipper' : 'Consignee'"
                          :items="masterFileData.shipperConsignee"
                          itemKey="Description"
                          descKey="Customer Name"
                          :selectedObject.sync="shipperConsignee"
                          :isDisabled="true"
                          :tableBoxHideColumns="['Description', 'Addr1', 'Addr2', 'Addr3', 'Addr4']"
                        />
                        <InputQuery
                          placeholder="Bill To"
                          :items="masterFileData.billTo"
                          itemKey="Description"
                          descKey="Customer Name"
                          :selectedObject.sync="billTo"
                          :isDisabled="true"
                          :tableBoxHideColumns="['Description']"
                        />
                        <Dropdown
                          placeholder="Payment"
                          :items="masterFileData.payment"
                          itemKey="Description"
                          :selectedObject.sync="paymentType"
                          :isDisabled="true"
                        />
                      </div>
                      <div class="container-info-row" style="grid-template-columns: repeat(3, 1fr)">
                        <Input :inputValue.sync="custRefNo" placeholder="Cust. Ref #" :isDisabled="true" />
                        <Input :inputValue.sync="projectNo" placeholder="Project #" :isDisabled="true" />
                        <DateTimePicker
                          placeholder="Request Date"
                          :value.sync="requestDate"
                          :showTime="false"
                          :isDisabled="true"
                        />
                      </div>
                    </div>
                    <div class="container-info-remarks">
                      <RemarksBox title="Job Remarks" :isDisabled="true" :maxLength="200" :text.sync="jobRemarks" />
                    </div>
                  </div>
                </div>
              </BoxContainer>
              <BoxContainer
                :isCollapsible="true"
                :isCollapsed.sync="cnDetailsBoxContainersCollapsed.containerInfo"
                title="Container Information"
                ref="containerInfo"
                @collapseArrowClicked="boxContainerCollapseArrowClicked"
              >
                <div class="container-info">
                  <div class="container-info-row">
                    <Input
                      :inputValue.sync="sealNo"
                      placeholder="Seal #"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="commodity"
                      placeholder="Commodity"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="contOperator"
                      placeholder="Cont. Operator"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="docNo"
                      :placeholder="cnDetails[0].DocTitle"
                      :isDisabled="true"
                    />
                    <InputQuery
                      placeholder="Billing Format"
                      :items="masterFileData.billingFmt"
                      itemKey="Description"
                      :selectedObject.sync="billingFmt"
                      :isDisabled="true"
                    />
                  </div>
                  <div class="container-info-row">
                    <Dropdown
                      :items="masterFileData.contSize"
                      itemKey="Size"
                      :selectedObject.sync="contSize"
                      placeholder="Size"
                      :isDisabled="true"
                    />
                    <Dropdown
                      :items="masterFileData.contType"
                      itemKey="Cont Type - Description"
                      :selectedObject.sync="contType"
                      placeholder="Type"
                      :isDisabled="true"
                    />
                    <Input :inputValue.sync="contTemperature" placeholder="Temperature" :isDisabled="true" />
                    <InputQuery
                      placeholder="Handling Type"
                      :items="masterFileData.handlingType"
                      itemKey="Handling Type - Description"
                      descKey="Description"
                      :selectedObject.sync="handlingType"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Handling Type - Description']"
                    />
                    <InputQuery
                      placeholder="Delivery Type"
                      :items="masterFileData.deliveryType"
                      itemKey="Delivery Type - Description"
                      descKey="Description"
                      :selectedObject.sync="delType"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Delivery Type - Description']"
                    />
                  </div>
                  <div class="container-info-row">
                    <Input
                      :inputValue.sync="contWeight"
                      placeholder="Weight (KG)"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="contHeight"
                      placeholder="Height"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="contMeasure"
                      placeholder="Measure"
                      :isDisabled="true"
                    />
                    <Dropdown
                      :items="masterFileData.trip"
                      itemKey="Description"
                      :selectedObject.sync="trip"
                      placeholder="Trip"
                      :isDisabled="true"
                    />
                    <Input :inputValue.sync="contStatus" placeholder="Status" :isDisabled="true" />
                  </div>
                  <div class="container-info-main">
                    <div class="container-info-fields">
                      <div class="container-info-row" style="grid-template-columns: repeat(4, 1fr)">
                        <DateTimePicker
                          :value.sync="planDate"
                          :showTime="false"
                          :isDisabled="true"
                          placeholder="Plan Date"
                        />
                        <Input :inputValue.sync="priority" placeholder="Priority" :isDisabled="true" />
                        <InputQuery
                          placeholder="Plan PM"
                          :items="masterFileData.primeMover"
                          itemKey="Code - Name"
                          :selectedObject.sync="planPM"
                          :isDisabled="true"
                          :tableBoxHideColumns="['Code - Name']"
                        />
                        <InputQuery
                          placeholder="Plan Driver"
                          :items="masterFileData.driver"
                          itemKey="Code - Name"
                          :selectedObject.sync="planDriver"
                          :isDisabled="true"
                          :tableBoxHideColumns="['Code - Name']"
                        />
                      </div>
                      <div class="container-info-row" style="grid-template-columns: repeat(4, 1fr)">
                        <DateTimePicker
                          :value.sync="requiredDate"
                          :showTime="false"
                          :isDisabled="true"
                          placeholder="Required Date"
                        />
                        <Input
                          :inputValue.sync="requiredTimeDesc"
                          placeholder="Required Time Desc."
                          :isDisabled="true"
                        />
                        <InputQuery
                          placeholder="Team"
                          :items="masterFileData.team"
                          itemKey="Team"
                          descKey="Description"
                          :selectedObject.sync="team"
                          :isDisabled="true"
                        />
                        <InputQuery
                          placeholder="Shift"
                          :items="masterFileData.shift"
                          itemKey="ShiftDesc"
                          :selectedObject.sync="shift"
                          :isDisabled="true"
                        />
                      </div>
                      <div style="display: flex; justify-content: space-between">
                        <div style="display: flex; width: 40%; margin-right: 10px">
                          <Dropdown
                            :items="masterFileData.jobType"
                            itemKey="Job Type"
                            :selectedObject.sync="jobType"
                            placeholder="Job Type"
                            :isDisabled="true"
                          />
                          <Input :inputValue.sync="coeff" placeholder="Coeff" :isDisabled="true" />
                        </div>
                        <CheckBoxV2 :isChecked.sync="officeHours" :isDisabled="true" title="Office Hrs" />
                        <CheckBoxV2 :isChecked.sync="fumigation" :isDisabled="true" title="Fumigation" />
                        <CheckBoxV2 :isChecked.sync="timbang" :isDisabled="true" title="Timbang" />
                        <CheckBoxV2 :isChecked.sync="isB2B" :isDisabled="true" title="B2B" />
                        <CheckBoxV2 :isChecked.sync="laden" :isDisabled="true" title="Laden" />
                      </div>
                    </div>
                    <div class="container-info-remarks">
                      <RemarksBox
                        title="Delivery Instructions"
                        :isDisabled="true"
                        style="height: 100%"
                        :maxLength="200"
                        :text.sync="CNRemarks"
                      />
                    </div>
                  </div>
                </div>
              </BoxContainer>
              <BoxContainer
                :isCollapsible="true"
                :isCollapsed.sync="cnDetailsBoxContainersCollapsed.sendToInfo"
                title="Send To Information"
                ref="sendToInfo"
                @collapseArrowClicked="boxContainerCollapseArrowClicked"
              >
                <div class="send-to-info" style="margin: 0; padding: 0; border: none">
                  <div class="send-to-container">
                    <InputQuery
                      placeholder="Pick Up"
                      :items="masterFileData.pickUp"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedPickUp"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Description', 'Address']"
                    />
                    <div class="address-container">{{ pickUpAddress }}</div>
                  </div>
                  <div class="send-to-container">
                    <InputQuery
                      placeholder="Send To"
                      :items="masterFileData.sendTo"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedSendTo"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Description']"
                    />
                    <div style="display: flex">
                      <CheckBoxV2
                        style="min-width: 90px"
                        :isChecked.sync="isDiversion"
                        :isDisabled="true"
                        title="Diversion"
                      />
                      <Dropdown
                        :items="masterFileData.premises"
                        itemKey="Premises Is"
                        :selectedObject.sync="premisesIs"
                        placeholder="Premises Is"
                        :isDisabled="true"
                      />
                    </div>
                    <div class="address-container">{{ sendToAddress }}</div>
                  </div>
                  <div class="send-to-container">
                    <InputQuery
                      placeholder="Drop Off"
                      :items="masterFileData.dropOff"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedDropOff"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Description', 'Address']"
                    />
                    <div class="address-container">{{ dropOffAddress }}</div>
                  </div>
                </div>
                <BoxContainer v-if="diversionList.length > 0" :isCollapsible="true" title="Diversions" ref="diversion">
                  <div class="diversion-info" v-for="d in diversionList" :key="d.index">
                    <div style="width: 100%; padding: 5px">
                      <div style="display: flex; width: 100%">
                        <InputQuery
                          :placeholder="diversionTitle(d)"
                          :isDisabled="true"
                          :items="masterFileData.sendTo"
                          itemKey="Description"
                          descKey="Company Name"
                          :selectedObject="d.location"
                        />
                      </div>
                      <RemarksBox
                        :title="diversionTitle(d)"
                        :isDisabled="true"
                        style="height: 100px"
                        :maxLength="200"
                        :text.sync="d.address"
                      />
                    </div>
                    <div style="width: 100%; padding: 5px">
                      <div style="padding-bottom: 11px">
                        <CheckBoxV2
                          title="Internal"
                          :isChecked.sync="d.internal"
                          :isDisabled="true"
                          style="margin-left: 5px; width: 100%; place-content: center"
                        />
                      </div>
                      <RemarksBox
                        :isDisabled="true"
                        style="height: 100px"
                        title="Remarks"
                        :maxLength="200"
                        :text.sync="d.remarks"
                      />
                    </div>
                  </div>
                </BoxContainer>
              </BoxContainer>
              <BoxContainer
                :isCollapsible="true"
                :isCollapsed.sync="cnDetailsBoxContainersCollapsed.voyageInfo"
                title="Voyage Information"
                ref="voyageInfo"
                @collapseArrowClicked="boxContainerCollapseArrowClicked"
              >
                <div class="container-info">
                  <div class="container-info-row">
                    <InputQuery
                      placeholder="Ship Call #"
                      :items="masterFileData.SCN"
                      itemKey="SCN - Terminal"
                      :selectedObject.sync="shipCallNo"
                      :isDisabled="true"
                      :search.sync="shipCallNoFreeText"
                      :allowFreeText="true"
                      :tableBoxHideColumns="['SCN - Terminal']"
                    />
                    <Input
                      :inputValue.sync="bookingRefNo"
                      placeholder="Booking Ref #"
                      :isDisabled="true"
                    />
                    <InputQuery
                      placeholder="Shipping Agent"
                      :items="masterFileData.shippingAgent"
                      itemKey="Code - Name"
                      descKey="Agent Name"
                      :selectedObject.sync="shippingAgent"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Code - Name']"
                    />
                    <InputQuery
                      placeholder="Tranship Port"
                      :items="masterFileData.port"
                      itemKey="Code - Name"
                      descKey="Port Location"
                      :selectedObject.sync="transhipPort"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Code - Name']"
                    />
                    <Input
                      :inputValue.sync="freeStorage"
                      placeholder="Free Storage"
                      :isDisabled="true"
                    />
                  </div>
                  <div class="container-info-row">
                    <Input
                      :inputValue.sync="voyageNo"
                      placeholder="Voyage #"
                      :isDisabled="true"
                    />
                    <Input 
                      :inputValue.sync="BLNo" 
                      placeholder="B/L #" 
                      :isDisabled="true" 
                    />
                    <InputQuery
                      placeholder="Forwarding Agent"
                      :items="masterFileData.fwdgAgent"
                      itemKey="Description"
                      descKey="FA Name"
                      :selectedObject.sync="fwdgAgent"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Description']"
                    />
                    <InputQuery
                      placeholder="Discharge Port"
                      :items="masterFileData.port"
                      itemKey="Code - Name"
                      descKey="Port Location"
                      :selectedObject.sync="dischargePort"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Code - Name']"
                    />
                    <Input
                      :inputValue.sync="freeDemurrage"
                      placeholder="Free Demurrage"
                      :isDisabled="true"
                    />
                  </div>
                  <div class="container-info-row">
                    <InputQuery
                      placeholder="Vessel #"
                      :items="masterFileData.vessel"
                      itemKey="Code - Name"
                      :selectedObject.sync="vesselID"
                      :isDisabled="true"
                      :tableBoxHideColumns="['Code - Name']"
                    />
                    <Input 
                      :inputValue.sync="requestedBy" 
                      placeholder="Requested By" 
                      :isDisabled="true" 
                    />
                    <Input 
                      :inputValue.sync="shippingLine" 
                      placeholder="Shipping Line" 
                      :isDisabled="true" 
                    />
                    <Input
                      :inputValue.sync="finalDestination"
                      placeholder="Final Destination"
                      :isDisabled="true"
                    />
                    <Input
                      :inputValue.sync="freeDetention"
                      placeholder="Free Detention"
                      :isDisabled="true"
                    />
                  </div>
                  <div class="container-info-row">
                    <DateTimePicker
                      :value.sync="ETADate"
                      :showTime="false"
                      :isDisabled="true"
                      placeholder="ETA Date"
                    />
                    <DateTimePicker
                      :value.sync="ETDDate"
                      :showTime="false"
                      :isDisabled="true"
                      placeholder="ETD Date"
                    />
                    <DateTimePicker
                      :value.sync="closingDate"
                      :showTime="false"
                      :isDisabled="true"
                      placeholder="Closing Date"
                    />
                    <DateTimePicker
                      :value.sync="demurrageDate"
                      :showTime="false"
                      :isDisabled="true"
                      placeholder="Demurrage Date"
                    />
                    <DateTimePicker
                      :value.sync="detentionDate"
                      :showTime="false"
                      :isDisabled="true"
                      placeholder="Detention Date"
                    />
                  </div>
                  <div class="container-info-row">
                    <CheckBoxV2 title="Offload @ Premises" :isChecked.sync="offload" :isDisabled="true" />
                  </div>
                </div>
              </BoxContainer>
            </div>
          </div>
          <BoxContainer
            :isCollapsible="true"
            :isCollapsed.sync="cnDetailsBoxContainersCollapsed.tripInfo"
            title="Trip Information"
            ref="tripInfo"
            @collapseArrowClicked="boxContainerCollapseArrowClicked"
          >
            <div class="trip-header">
              Delivery
              <div class="trip-header-info">
                <Input :inputValue.sync="deliveryAdvisedDate" placeholder="Advised Date" :isDisabled="true" />
                <Input :inputValue.sync="deliveryRequiredDate" placeholder="Required Date" :isDisabled="true" />
                <Input :inputValue.sync="deliveryPlannedFor" placeholder="Planned For" :isDisabled="true" />
                <Input :inputValue.sync="deliveryEventDate" placeholder="Event Date" :isDisabled="true" />
              </div>
              Collection
              <div class="trip-header-info">
                <Input :inputValue.sync="collectionAdvisedDate" placeholder="Advised Date" :isDisabled="true" />
                <Input :inputValue.sync="collectionRequiredDate" placeholder="Required Date" :isDisabled="true" />
                <Input :inputValue.sync="collectionPlannedFor" placeholder="Planned For" :isDisabled="true" />
                <Input :inputValue.sync="collectionEventDate" placeholder="Event Date" :isDisabled="true" />
              </div>
            </div>
            <div class="details-table">
              <Table-Box :tableData="tripTableData" title="Trip Details" :maxSelection="0" />
            </div>
            <div class="details-table">
              <TableBox
                :tableData="statusRemarksData"
                title="Status Remarks"
                :hideColumns="['ConsignmentNo', 'seqno']"
                :maxSelection="0"
                :hideBottomBlock="true"
              />
            </div>
          </BoxContainer>
          <BoxContainer
            :isCollapsible="true"
            :isCollapsed.sync="cnDetailsBoxContainersCollapsed.docInfo"
            title="Documents"
            ref="docInfo"
            @collapseArrowClicked="boxContainerCollapseArrowClicked"
          >
            <div class="details-table">
              <TableBox
                :tableData="cnDetails[0].InvoiceDetails"
                title="Document Details"
                :dataType="{ Date: 'datetime', 'Consignment Amount': 'number', 'Total Amount': 'number' }"
                :hideColumns="['ConsignmentNo']"
                :maxSelection="0"
                :hideBottomBlock="true"
              />
            </div>
          </BoxContainer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    // SendToAdrress: function() {
    //   if (!this.cnDetails || this.cnDetails.length === 0) {
    //     return "";
    //   }

    //   const detail = this.cnDetails[0];
    //   const address = [];

    //   // function to bold text
    //   const bold = (value) => `<b>${value}</b>`;

    //   if (detail.SendToCompany) address.push(bold(detail.SendToCompany));
    //   if (detail.SendToAddr1) address.push(bold(detail.SendToAddr1));
    //   if (detail.SendToAddr2) address.push(bold(detail.SendToAddr2));
    //   if (detail.SendToAddr3) address.push(bold(detail.SendToAddr3));

    //   const addr1 = [];
    //   if (detail.SendToPostCode) addr1.push(detail.SendToPostCode);
    //   if (detail.SendToCity) addr1.push(detail.SendToCity);

    //   if (addr1.length > 0) {
    //     address.push(bold(addr1.join(", ")));
    //   }

    //   const addr2 = [];
    //   if (detail.SendToState) addr2.push(bold(detail.SendToState));
    //   if (detail.SendToCountry) addr2.push(bold(detail.SendToCountry));

    //   if (addr2.length > 0) {
    //     address.push(bold(addr2.join(", ")));
    //   }

    //   return address.join("<br>");
    // },
    // cnDetailsCardHeaderStyle: function() {
    //   if (
    //     !this.cnDetailsCardHeaderBackgroundColor ||
    //     this.cnDetailsCardHeaderBackgroundColor === "white" ||
    //     !this.cnDetailsCardHeaderBackgroundColor.startsWith("#")
    //   ) {
    //     return {
    //       "background-color": "white",
    //       "color": "black",
    //     };
    //   }

    //   let backgroundColor = this.cnDetailsCardHeaderBackgroundColor.replace("#", "");
    //   if (backgroundColor.length == 3) { // if there are only 3 hex digits
    //     backgroundColor = backgroundColor[0] + backgroundColor[0] + backgroundColor[1] + backgroundColor[1] + backgroundColor[2] + backgroundColor[2];
    //   }

    //   const red = parseInt(backgroundColor.slice(0, 2), 16); // convert from hex to decimal
    //   const green = parseInt(backgroundColor.slice(2, 4), 16);
    //   const blue = parseInt(backgroundColor.slice(4, 6), 16);

    //   let textColor;
    //   if (((red + green + blue) / 3) > 100) {
    //     textColor = 'black';
    //   } else {
    //     textColor = 'white';
    //   }

    //   return {
    //     "background-color": this.cnDetailsCardHeaderBackgroundColor,
    //     "color": textColor,
    //   };
    // },
    // premisesStatus: function() {
    //   return this.cnDetails?.[0]?.PremisesIs || ''
    // },
    // premisesColor: function() {
    //   return this.premisesStatus.toUpperCase() === 'UNSECURED'
    //     ? 'red'
    //     : ''
    // },
    diversionTitle: function () {
      return (d) => `Diversion Loc ${d.index}`;
    },
  },
  data: function () {
    return {
      cnDetailsCardHeaderBackgroundColor: '#535cda',
      cnDetailsBoxContainersCollapsed: {
        containerInfo: false,
        jobInfo: false,
        sendToInfo: false,
        voyageInfo: false,
        tripInfo: false,
        docInfo: false,
      },

      updatedBy: '',
      lastUpdated: '',
      containerNo: '',
      requestNo: '',

      //#region Container Information
      commodity: '',
      contSize: null,
      contType: null,
      contTemperature: '',
      contMeasure: '',
      contWeight: '',
      contHeight: '',
      contOperator: '',
      docNo: '',
      contStatus: '',
      handlingType: null,
      delType: null,
      sealNo: '',
      trip: null,
      fumigation: false,
      officeHours: false,
      isB2B: false,
      timbang: false,
      team: null,
      billingFmt: null,
      laden: false,
      CNRemarks: '',
      requiredDate: null,
      requiredTimeDesc: '',
      priority: '',
      shift: null,
      planDate: null,
      planPM: null,
      planDriver: null,
      //#endregion

      //#region Job Header Information
      shipperConsignee: null,
      billTo: null,
      jobType: null,
      custRefNo: '',
      requestDate: null,
      projectNo: '',
      coeff: '',
      paymentType: null,
      jobRemarks: '',
      //#endRegion

      //#region Send To Information
      selectedPickUp: null,
      selectedSendTo: null,
      selectedDropOff: null,
      pickUpAddress: '',
      sendToAddress: '',
      dropOffAddress: '',
      isDiversion: false,
      premisesIs: null,

      diversionList: [],
      //#endregion

      //#region Voyage Information
      BLNo: '',
      bookingRefNo: '',
      shippingLine: '',
      shipCallNo: null,
      shipCallNoFreeText: '',
      fwdgAgent: null,
      shippingAgent: null,
      vesselID: null,
      voyageNo: '',
      dischargePort: null,
      closingDate: null,
      demurrageDate: null,
      detentionDate: null,
      ETADate: null,
      ETDDate: null,
      transhipPort: null,
      finalDestination: '',
      requestedBy: '',
      offload: false,
      freeStorage: '',
      freeDemurrage: '',
      freeDetention: '',
      //#endregion

      //#region Trip Information
      deliveryAdvisedDate: '',
      deliveryRequiredDate: '',
      deliveryPlannedFor: '',
      deliveryEventDate: '',
      collectionAdvisedDate: '',
      collectionRequiredDate: '',
      collectionPlannedFor: '',
      collectionEventDate: '',
      //#endregion

      tripTableData: [],
      statusRemarksData: [],
    };
  },
  props: {
    cnDetails: {
      type: Array,
      default: function () {
        return null;
      },
    }, // consignment details passed
    // expected format for cnDetails:
    // obobtainable from API endpoint: Service6G.svc/GetCNDetails
    // [
    //   {
    //     PUArea: "WP",
    //     DOArea: "WP",
    //     PickUp: "KMT",
    //     DropOff: "GFORTUNE",
    //     ConsignmentNo: "LI0137797-001",
    //     RequestNo: "B25005882",
    //     ContainerNo: "EMCU1611193",
    //     ContSizeType: "40HC",
    //     HandlingType: "N",
    //     DeliveryType: "TR",
    //     TotalCount: 3,
    //     CurrentStatus: "Pending Delivery",
    //     Operator: "EMC",
    //     Commodity: "WHEEL DISC",
    //     Trip: "1         ",
    //     PremisesIs: "UNSECURED",
    //     SendToCode: "WZ12",
    //     SendToArea: "BTGKL",
    //     SendToCompany: "WAREHOUSE ZURAH",
    //     SendToAddr1: "LOT PT803, JALAN ZURAH 7",
    //     SendToAddr2: "KAWASAN PERINDUSTRIAN ZURAH",
    //     SendToAddr3: "",
    //     SendToPostCode: "44200",
    //     SendToCity: "BATANG KALI",
    //     SendToState: "",
    //     SendToCountry: "",
    //     ContactPerson: "NISA",
    //     ContactEmail: "-",
    //     Phone1: "0102361980",
    //     Phone2: "-",
    //     Fax1: "-",
    //     Fax2: "-",
    //     RequiredDate: "2025-05-31 10:00",
    //     RequestDate: "2025-05-30 15:09",
    //     CloseDate: "-",
    //     ETADate: "2025-05-28 08:00",
    //     ETDDate: "-",
    //     DateDemurrage: "-",
    //     DateDetention: "-",
    //     PlannedDate: "-",
    //     SCN: "254SOE",
    //     VesselNo: "FIT694199",
    //     VesselName: "ITAL BONUS",
    //     ShipLine: "BS0557",
    //     ForwardingAgent: "TLS01",
    //     ShippingAgent: "BS0218",
    //     DischargePort: "JAKARTA",
    //     DocNo: "-",
    //     DocTitle: "Gate Pass",
    //     SealNo: "EMCPKW9374",
    //     OfficeHrs: 1,
    //     LastUserID: "HAZRIE01            ",
    //     LastDateUpdated: "2025-05-30 15:09",
    //     JobType: "IMP",
    //     BillTo: "3000TL01",
    //     Fumigation: "N",
    //     CNLastUpStatus: "8001 ",
    //     JobRemarks: null,
    //     VoyNo: "0453-103N",
    //     BL_No: "",
    //     CustRef: "P2I02350525",
    //     ShprCsgnName: "PERODUA GLOBAL MANUFACTURING SDN BHD",
    //     ShprCsgnCode: "TL01PG01",
    //     BookingRefNo: "HASLS16250800605"
    //   },
    // ];
    masterFileData: { type: Object, default: () => ({}) }, // master data for fields
    tripDetails: {
      type: Array,
      default: function () {
        return null;
      },
    }, // consignment trip details
    isLoading: { type: Boolean, default: false }, // loading state prop
  },
  methods: {
    expandAllBoxContainers: function () {
      if (this.isLoading) return;
      Object.keys(this.cnDetailsBoxContainersCollapsed).forEach((key) => {
        this.cnDetailsBoxContainersCollapsed[key] = false;
      });
    },
    collapseAllBoxContainers: function () {
      if (this.isLoading) return;
      Object.keys(this.cnDetailsBoxContainersCollapsed).forEach((key) => {
        this.cnDetailsBoxContainersCollapsed[key] = true;
      });
    },
    boxContainerCollapseArrowClicked: function (collapsed, refName) {
      if (this.isLoading) return;
      if (!collapsed) {
        this.$nextTick(() => {
          if (this.$refs[refName]) {
            this.$refs[refName].updateExpandedHeight();
          }
        });
      }
    },
    reupdateExpandedHeight: function () {
      Object.keys(this.$refs).forEach((ref) => {
        if (this.$refs[ref] && this.$refs[ref].updateExpandedHeight) {
          this.$refs[ref].updateExpandedHeight();
        }
      });
    },
    getAddress: function (val) {
      let address = '';
      if (val) {
        address += `${val['Addr1'] ? val['Addr1'].trim() : ''}\n`;
        address += `${val['Addr2'] ? val['Addr2'].trim() : ''}\n`;
        address += `${val['Addr3'] ? val['Addr3'].trim() : ''}\n`;
        address += `${val['Addr4'] ? val['Addr4'].trim() : ''}\n`;
        address += `${val['PostCode'] ? val['PostCode'].trim() : ''}, ${val['City'] ? val['City'].trim() : ''}\n`;
        address += `${val['State'] ? val['State'].trim() : ''}, ${val['Country'] ? val['Country'].trim() : ''}`;
      }
      return address;
    },
    populateDiversionDetails: async function () {
      this.$fullscreenLoading('Getting Diversion Details');
      const diversions = await this.$apiCallV2(
        `/HaulageJob/GetHMSDiversion?jobno=${this.cnDetails[0].JobNo}&cnno=${this.cnDetails[0].ConsignmentNo}`,
      );
      this.$fullscreenLoading();

      diversions.forEach((d) => {
        // Populate diversion list
        const diversionLoc = this.masterFileData.sendTo.getSelected(d['Diversion Dest'], 'Destination Code');

        this.diversionList.push({
          index: d['Seq'],
          location: diversionLoc,
          address: d['DiverAddress'],
          remarks: d['Remarks'],
          internal: d['DeliveryMode'] == 1,
        });
      });
    },
    populateConsignmentDetails: function () {
      const details = this.cnDetails[0];

      this.updatedBy = details['LastUserID'];
      this.lastUpdated = details['LastDateUpdated'];
      this.containerNo = details['ContainerNo'];
      this.requestNo = details['RequestNo'];

      //#region Container Information
      this.sealNo = details['SealNo'];
      this.commodity = details['Commodity'];
      this.contOperator = details['Operator'];
      this.contWeight = details['Weight'];
      this.contHeight = details['Height'];
      this.contTemperature = details['Temperature'];
      this.contMeasure = details['Measure'];
      this.contStatus = details['CurrentStatus'];
      this.docNo = details['DocNo'];
      this.officeHours = details['OfficeHrs'] == 1;
      this.fumigation = details['Fumigation'] == 'N';
      this.timbang = details['Timbang'] == 'N';
      this.isB2B = details['B2B'] == '1';
      this.laden = details['Laden'] == 'L';
      this.CNRemarks = details['CNRemarks'];
      this.requiredDate = new Date(details['RequiredDate']);
      this.requiredTimeDesc = details['ReqTimeDesc'];
      this.planDate = new Date(details['PlannedDate']);
      this.priority = details['Priority'];

      const [size, type] = [details['ContSizeType'].slice(0, 2), details['ContSizeType'].slice(2)];
      this.contSize = this.masterFileData.contSize.getSelected(size, 'Size');
      this.contType = this.masterFileData.contType.getSelected(type, 'Cont Type');
      this.handlingType = this.masterFileData.handlingType.getSelected(details['HandlingType'], 'Handling Type');
      this.delType = this.masterFileData.deliveryType.getSelected(details['DeliveryType'], 'Delivery Type');
      this.trip = this.masterFileData.trip.getSelected(details['Trip'], 'Trip');
      this.team = this.masterFileData.team.getSelected(details['Team'], 'Team');
      this.billingFmt = this.masterFileData.billingFmt.getSelected(details['BillingFmt'], 'Billing Fmt');
      this.planPM = this.masterFileData.primeMover.getSelected(details['PlannedPM'], 'PM Number') || null;
      this.planDriver = this.masterFileData.driver.getSelected(details['PlannedDriver'], 'Driver Code') || null;
      this.shift = this.masterFileData.shift.getSelected(details['ShiftID'], 'Shift ID');
      //#endregion

      //#region Job Information
      this.custRefNo = details['CustRef'];
      this.requestDate = new Date(details['RequestDate']);
      this.projectNo = details['ProjectNo'];
      this.coeff = details['Coeff'];
      this.jobRemarks = details['JobRemarks'];

      this.shipperConsignee = this.masterFileData.shipperConsignee.getSelected(details['ShprCsgnCode'], 'Customer Code');
      this.billTo = this.masterFileData.billTo.getSelected(details['BillTo'], 'Customer Code');
      this.jobType = this.masterFileData.jobType.getSelected(details['JobType'], 'Job Type');
      this.paymentType = this.masterFileData.payment.getSelected(details['PaymentType'], 'Payment Type');
      //#endregion

      //#region Send To Information
      this.isDiversion = details['IsDiversion'] == '1';
      this.premisesIs =
        details['PremisesIs'] == 'UNSECURED' ? this.masterFileData.premises[0] : this.masterFileData.premises[1];
      this.selectedPickUp = this.masterFileData.pickUp.getSelected(details['PickUp'], 'Destination Code');
      this.pickUpAddress = this.getAddress(this.selectedPickUp);
      this.selectedSendTo = this.masterFileData.sendTo.getSelected(details['SendToCode'], 'Destination Code');
      this.sendToAddress = this.getAddress(this.selectedSendTo);
      this.selectedDropOff = this.masterFileData.dropOff.getSelected(details['DropOff'], 'Destination Code');
      this.dropOffAddress = this.getAddress(this.selectedDropOff);
      //#endregion

      //#region Voyage Information
      this.BLNo = details['BL_No'];
      this.shippingLine = details['ShipLine'];
      this.voyageNo = details['VoyNo'];
      this.bookingRefNo = details['BookingRefNo'];
      this.offload = details['OffLoad'] == '1';
      this.finalDestination = details['FinalDestination'];
      this.requestedBy = details['RequestedBy'];
      this.closingDate = new Date(details['CloseDate']);
      this.ETADate = new Date(details['ETADate']);
      this.ETDDate = new Date(details['ETDDate']);
      this.demurrageDate = new Date(details['DateDemurrage']);
      this.detentionDate = new Date(details['DateDetention']);

      const storageUnit = details['StorageUnit'] == 'H' ? 'Hours' : 'Days';
      const demurrageUnit = details['DemurrageUnit'] == 'H' ? 'Hours' : 'Days';
      const detentionUnit = details['DetentionUnit'] == 'H' ? 'Hours' : 'Days';
      this.freeStorage = details['FreeStorage'] ? `${details['FreeStorage']} ${storageUnit}` : '';
      this.freeDemurrage = details['FreeDemurrage'] ? `${details['FreeDemurrage']} ${demurrageUnit}` : '';
      this.freeDetention = details['FreeDetention'] ? `${details['FreeDetention']} ${detentionUnit}` : '';

      this.shipCallNo = this.masterFileData.SCN.getSelected(details['SCN'], 'Ship Call No');
      this.shipCallNoFreeText = this.shipCallNo ? '' : details['SCN'];
      this.fwdgAgent = this.masterFileData.fwdgAgent.getSelected(details['ForwardingAgent'], 'FA Code');
      this.shippingAgent = this.masterFileData.shippingAgent.getSelected(details['ShippingAgent'], 'Agent Code');
      this.vesselID = this.masterFileData.vessel.getSelected(details['VesselNo'], 'Vessel ID');
      this.dischargePort = this.masterFileData.port.getSelected(details['POD'], 'Port Code');
      this.transhipPort = this.masterFileData.port.getSelected(details['POT'], 'Port Code');
      //#endregion

      //#region Trip Information
      this.deliveryAdvisedDate = this.tripDetails[0] ? this.tripDetails[0]['Advised Date'] : '';
      this.deliveryRequiredDate = this.tripDetails[0] ? this.tripDetails[0]['Required Date'] : '';
      this.deliveryPlannedFor = this.tripDetails[0] ? this.tripDetails[0]['Planned For'] : '';
      this.deliveryEventDate = this.tripDetails[0] ? this.tripDetails[0]['Event Date'] : '';

      this.collectionAdvisedDate = this.tripDetails[1] ? this.tripDetails[1]['Advised Date'] : '';
      this.collectionRequiredDate = this.tripDetails[1] ? this.tripDetails[1]['Required Date'] : '';
      this.collectionPlannedFor = this.tripDetails[1] ? this.tripDetails[1]['Planned For'] : '';
      this.collectionEventDate = this.tripDetails[1] ? this.tripDetails[1]['Event Date'] : '';
      //#endregion
    },
    populateTripDetails: function () {
      let seq = 1;
      this.tripTableData = [];
      this.tripDetails.forEach((movement) => {
        if (Array.isArray(movement['Trips'])) {
          movement.Trips.forEach((trip) => {
            // Pickup details
            this.tripTableData.push({
              '#': seq,
              'Mvt.': trip['Movement'],
              Driver:
                trip['Driver No'] ?
                  `(${trip['Driver No']}) ${trip['Driver Name']} / TEL: ${trip['Driver Tel'] || '-'} / IC: ${trip['Driver IC'] || '-'}`
                : '',
              'Prime Mover': trip['PM'] ? `(${trip['PM']}) ${trip['PMNo']}` : '',
              Trailer: trip['TR'] ? `(${trip['TR']}) ${trip['TRNo']}` : '',
              'Date Completed': trip['From Date Completed'],
              Location: trip['From Location'],
              Area: trip['From Area'],
              Status: trip['From Status Desc'],
              Remarks: trip['Remarks'],
              'Date Updated': trip['From Date Updated'],
              UserID: trip['From UserID'],
              B2B: trip['B2B Consignment No'],
              'TR Detach': 'No',
              'Work Ticket Date': trip['Work Ticket Date'],
            });
            // Dropoff details
            this.tripTableData.push({
              '#': `${seq + 1}`,
              'Mvt.': '',
              Driver: '',
              'Prime Mover': '',
              Trailer: '',
              'Date Completed': trip['To Date Completed'],
              Location: trip['To Location'],
              Area: trip['To Area'],
              Status: trip['To Status Desc'],
              Remarks: '',
              'Date Updated': trip['To Date Updated'],
              UserID: trip['To UserID'],
              B2B: trip['B2B Consignment No'],
              'TR Detach': trip['TR Detached'] == 1 ? 'Yes' : 'No',
              'Work Ticket Date': '',
            });
            seq += 2;
          });
        }
      });
      // Status Remarks
      this.statusRemarksData =
        this.cnDetails[0].StatusDetails?.map((item) => ({
          ...item,
          Status:
            item.Status === 'Delivery Remarks' ?
              '<div style="background-color: orange; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Delivery Remarks</div>'
            : '<div style="background-color: #1E90FF; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Collection Remarks</div>',
        })) ?? [];
    },
  },
  async mounted() {
    this.$bus.$on('backColorChanged', (backgroundColor) => {
      // getting backgroundColor from user options is asynch, therefore need to listen to an event
      this.cnDetailsCardHeaderBackgroundColor = backgroundColor; // and change the background color of the header once it has finished loading
    });
    this.cnDetailsCardHeaderBackgroundColor = this.$store.state['backgroundColor']; // initialise background color to whatever is in vuex at the time of component mount

    // Populate fields
    await this.populateDiversionDetails();
    this.populateConsignmentDetails();
    this.populateTripDetails();

    this.reupdateExpandedHeight();
  },
  beforeDestroy() {
    this.$bus.$off('backColorChanged'); // stop listening to the event
  },
  watch: {
    cnDetails: {
      deep: true,
      handler: function () {
        this.$nextTick(() => {
          this.reupdateExpandedHeight();
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.consignment-details-main {
  > .content-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .header {
      margin-bottom: 5px;
      border-radius: 5px 5px 0 0;
      height: 30px;
      width: 100%;
      padding-left: 5px;
      display: flex;
      align-items: center;
      position: sticky;
      top: 0;
      z-index: 99;

      > .title {
        color: white;
        font-weight: bold;
      }
    }

    > .body-container {
      position: relative;
      height: calc(100% - 30px);
      width: 100%;
      transition: opacity 0.3s ease;

      &.is-loading {
        opacity: 0.4;
        pointer-events: none;
      }

      .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        background-color: rgba(255, 255, 255, 0.1);

        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #535cda;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}

.cn-details-card {
  margin-bottom: 10px;
  border-radius: 5px;
  height: fit-content;
  width: 100%;

  > .header {
    border-bottom: 1px solid black;
    border-radius: 5px 5px 0 0;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 999;

    > .label {
      font-weight: bold;
    }

    > .expand-all,
    > .collapse-all {
      position: absolute;
      height: 20px;
      width: 20px;
      transition: 0.3s;
      cursor: pointer;
      filter: brightness(0) invert(1);

      &:hover {
        height: 40px;
        width: 40px;
      }
    }

    > .expand-all {
      right: 45px;

      &:hover {
        right: 35px;
      }
    }

    > .collapse-all {
      right: 15px;

      &:hover {
        right: 5px;
      }
    }
  }

  > .details-container {
    padding: 5px;
    display: flex;
    flex-direction: column;
  }

  > .cn-details {
    display: flex;
    flex-direction: column;
  }
}

.details-table-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .details-table {
    width: 100%;
  }
  .details-table .label {
    width: 22%;
  }
  .details-table .colon {
    width: 1%;
  }
  .details-table .details {
    width: 27%;
  }
  .details-table .spacer {
    width: 0.5%;
  }
}

.container-info {
  padding: 10px;

  > .container-info-main {
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 10px;
    align-items: stretch;

    > .container-info-fields {
      display: flex;
      flex-direction: column;
    }
  }

  .container-info-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 5px;
    margin: 2px 0px;

    > .container-info-row:last-child {
      margin-bottom: 0;
    }
  }

  .container-info-remarks {
    min-height: 100%;
  }

  > .top-details {
    display: flex;
    gap: 12px;
  }
}

.send-to-info {
  border: 1px solid gray;
  padding: 5px;
  padding-top: 10px;
  margin-top: 15px;
  display: flex;
  position: relative;

  > .send-to-container {
    flex: 1 1 0;
    min-width: 0;
    border: 1px solid gray;
    padding: 5px;
    margin: 2px;
    padding-top: 10px;

    > .address-container {
      white-space: pre-wrap;
      padding-left: 10px;
    }
  }
}

.diversion-info {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding-left: 0px;
  margin: 0px;
}

.details-table {
  padding: 5px;
  padding-top: 0;
}

.trip-header {
  padding: 5px;

  > .trip-header-info {
    display: flex;
    padding-top: 3px;
    gap: 5px;
  }
}
</style>
